import React from 'react';

/**
 * Reusable season dropdown.
 * Props:
 *   seasons        – array of season objects from /seasons
 *   selectedId     – currently selected season id (string or number)
 *   onChange(id)   – called with the new season id (string) when user picks one
 */
const SeasonSelector = ({ seasons, selectedId, onChange }) => {
  if (!seasons || seasons.length === 0) return null;

  return (
    <div className="flex items-center gap-2">
      <label className="text-sm font-medium text-gray-600 dark:text-gray-400 whitespace-nowrap">
        Season:
      </label>
      <select
        value={selectedId || ''}
        onChange={(e) => onChange(e.target.value)}
        className="px-3 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {seasons.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
            {s.isActive ? ' ★' : s.completed ? ' ✓' : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SeasonSelector;
